<template>
  <div
      :class="wrapperClass"
      role="radiogroup"
      :aria-invalid="error ? 'true' : 'false'"
  >
    <div
      ref="actualInput"
        :class="{
      'custom-toggle':true,
      'v-btn-group':true,
      'v-btn-group--density-compact': compact,
      'v-btn-group--density-default': !compact,
      'error': error === true,
      'compact': compact
    }"
    >
      <input
          type="radio"
          :id="idFalse"
          value="0"
          @change="onChange('0')"
          :disabled="disabled"
          :readonly="readonly"
          :checked="internalValue === '0'"
      />
      <label :for="idFalse">{{ labelFalse }}</label>

      <input
          type="radio"
          :id="idTrue"
          value="1"
          @change="onChange('1')"
          :disabled="disabled"
          :readonly="readonly"
          :checked="internalValue === '1'"
      />
      <label :for="idTrue">{{ labelTrue }}</label>
    </div>
    <div :class="['v-input__details', { 'invisible': !error }]" role="alert" aria-live="polite">
      <div class="v-messages">
        <div class="v-messages__message" v-for="(msg, i) in errorMessages" :key="i">{{ msg }}</div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: ''
  },
  rules: {
    type: Array,
    default: () => []
  },
  compact: Boolean,
  disabled: Boolean,
  readonly: Boolean
})

const emit = defineEmits(['submit', 'formIsInvalid'])

const { t } = useI18n()

const internalValue = ref(null)
const actualInput = ref(null)

const labelTrue = t('global.text.bool.true', 'Yes')
const labelFalse = t('global.text.bool.false', 'No')

const idFalse = computed(() => `yes-no-false-${Math.random().toString(36).slice(2)}`)
const idTrue = computed(() => `yes-no-true-${Math.random().toString(36).slice(2)}`)

const errorMessages = ref([])
const error = ref(false)

const wrapperClass = computed(() => [
  'mt-2 mb-0 v-input v-input--horizontal v-input--center-affix',
  { 'd-flex align-center flex-column': props.compact }
])

function validate(val = null) {
  if (val === null) {
    val = internalValue.value
  }
  errorMessages.value = []

  for (const rule of props.rules || []) {
    let result
    try {
      result = rule(val)
    } catch (e) {
      result = e.message || 'Validation error'
    }

    if (result !== true) {
      error.value = true
      errorMessages.value.push(result)
      emit('formIsInvalid')
      return false
    }
  }

  error.value = false
  return true
}

function onChange(val) {
  internalValue.value = val?.toString() ?? ''
  if (validate(val)) {
    emit('submit', val)
  }
}

defineExpose({
  validate,
  focus() {
    actualInput.value.focus()
  },
  scrollIntoView(e) {
    actualInput.value.scrollIntoView(e)
  },
  resetValidation() {
    errorMessages.value = []
    error.value = false
  }
})

watch(() => props.modelValue, (val) => {
  if (val === null && internalValue.value !== null) {
    return;
  }
  internalValue.value = val?.toString() ?? ''
}, { immediate: true })
</script>
